const initCheckoutErrors = () => {
  const errorsContainer = document.querySelector('[data-validation-errors]');

  if (!errorsContainer) {
    return;
  }

  jQuery(document.body).on('checkout_error', () => {
    errorsContainer
      .querySelectorAll('[data-woo-error]')
      .forEach((error) => error.remove());

    const notices = document.querySelector('.woocommerce-NoticeGroup-checkout');

    if (!notices) {
      return;
    }

    notices.querySelectorAll('li').forEach((notice) => {
      const error = document.createElement('div');

      error.className = 'errors__error';
      error.dataset.wooError = '';

      error.innerHTML = `
        <svg width="20" height="20" aria-hidden="true">
          <use xlink:href="#icon-error"></use>
        </svg>
        <span>${notice.textContent.trim()}</span>
      `;

      errorsContainer.append(error);
    });

    notices.remove();
  });
};

export {initCheckoutErrors};
